import React from 'react';
import PropTypes from 'prop-types';

import 'react-quill/dist/quill.snow.css'; // ES6
import ReactQuill from 'react-quill'; // ES6

const CustomToolbar = ({ onClickRaw, text }) => (
    <div id="toolbar">
        <span className="ql-formats">
            <select className="ql-header" defaultValue={''}>
                <option value="1" />
                <option value="2" />
                <option value="" />
            </select>
        </span>
        <span className="ql-formats">
            <select className="ql-color">
                <option value="red" />
                <option value="green" />
                <option value="blue" />
                <option value="orange" />
                <option value="violet" />
                <option value="#d0d1d2" />
                <option defaultValue />
            </select>
        </span>
        <span className="ql-formats">
            <button className="ql-bold" />
            <button className="ql-italic" />
            <button className="ql-underline" />
            <button className="ql-strike" />
            <button className="ql-blockquote" />
        </span>

        <span className="ql-formats">
            {/* 
            <button className="ql-list" value="ordered" />
            <button className="ql-list" value="bullet" />
            <button className="ql-indent" value="-1" />
            <button className="ql-indent" value="+1" />
            */}
            <button className="ql-clean" />
        </span>
    </div>
);

class Editor extends React.Component {
    state = {
        value: undefined,
        theme: 'snow',
    };

    static getDerivedStateFromProps(props, state) {
        const { value, name } = props;
        if (state.name !== name || state.value !== value) {
            state.value = value;
            state.name = name;
            return state;
        }
        return null;
    }

    handleBlur = (range, source, quill) => {
        this.setState({ range: range });
    };

    handleClickShowRaw = () => {
        this.setState({ open: true, range: this.reactQuillRef.getEditor().getSelection() });
    };

    handleChange = (html, delta, source) => {
        if (source === 'user')
            this.props.onChange({ target: { name: this.props.name, value: html } });
    };

    render() {
        const { theme, value } = this.state;
        return (
            <React.Fragment>
                <CustomToolbar
                    onClickRaw={this.handleClickShowRaw}
                    text={this.props.intl.formatMessage({ id: 'form_field_name_campos' })}
                />
                {value !== undefined && (
                    <ReactQuill
                        ref={(el) => {
                            this.reactQuillRef = el;
                        }}
                        theme={theme}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        defaultValue={value}
                        modules={Editor.modules}
                        formats={Editor.formats}
                        bounds={'.app'}
                        placeholder={this.props.placeholder}
                    />
                )}
                
            </React.Fragment>
        );
    }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
    toolbar: {
        container: '#toolbar',
        handlers: {},
    },
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: true,
    },
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
    'header',
    'font',
    'size',
    'value',
    'style',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'color',
    'link',
    'image',
    'video',
    'variable',
    'nombre',
];

/*
 * PropType validation
 */
Editor.propTypes = {
    placeholder: PropTypes.string,
};

export default Editor;



// WEBPACK FOOTER //
// ./src/components/complex/communications/Editor.js